function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.2,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 1154 1010",
    width: 25,
    height: 22
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1080 576v-72H288v72h792zm0-360v-72H288v72h792zm0 720v-72H288v72h792zM108 135c-24 0-45 21-45 45s21 45 45 45 45-21 45-45-21-45-45-45zm0-63c59 0 108 49 108 108s-49 108-108 108S0 239 0 180 49 72 108 72zm0 423c-24 0-45 21-45 45s21 45 45 45 45-21 45-45-21-45-45-45zm0-63c59 0 108 49 108 108s-49 108-108 108S0 599 0 540s49-108 108-108zm0 423c-24 0-45 21-45 45s21 45 45 45 45-21 45-45-21-45-45-45zm0-63c59 0 108 49 108 108s-49 108-108 108S0 959 0 900s49-108 108-108z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke",
    style: {
      "fill": "rgb(48, 48, 48)"
    }
  })));
};

export default __webpack_public_path__ + "static/media/table.e6e31239.svg";
export { SvgComponent as ReactComponent };